import { render, staticRenderFns } from "./Kyc.vue?vue&type=template&id=3f09a6a6"
import script from "./Kyc.vue?vue&type=script&lang=js"
export * from "./Kyc.vue?vue&type=script&lang=js"
import style0 from "./Kyc.vue?vue&type=style&index=0&id=3f09a6a6&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports